// extracted by mini-css-extract-plugin
export default {"fixedButton":"RIblqccmMZvRepPMRV_w","open":"s0ryK1ogZEfpTtu5S9QI","fullButton":"oyZrK53q3GO3QR3kIpQa"};